export * from "./DynamsoftScanner";
export { default as DynamsoftScanner } from "./DynamsoftScanner";

